function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.943 11.238c-.207-.15-2 2-3.664 1.53-1.263-.358-2.118 1.69-2.334 1.172-1.607-3.855 3.998-6.702 3.998-6.702-1.381-1.429-3-1-3-4 1.393.037 3.214 2.102 5 4-.624-2.263-.076-3.984 2-5 .919 1.598 0 2-1 4 0 0 4.892 13.442 11.114 19.105 3.64 3.313 15.39 2.358 16.505 7.152.649 2.793-.811 4.382-1.79 7.077-.58 1.592 1.072 1.963.978 4.705-.146 4.289-.807 10.962-.807 10.962h-3s1.645-6.769 1.114-10.076C34.537 41.92 31.943 41.239 29 36c-1.726 1.687-8.384-.97-8.543-.381-1.514 5.619.486 18.619.486 18.619h-4s.948-1.947 1-3c.152-3.106 1-7-2.205-21.458-2.795-1.543-1.795-4.943-5.795-18.942"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.943 31.238c3.827 1.042 5.271 3.946 6 7.41-1.58-2.124-2.835-5.467-5-5.41"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.871,
  cy: 9.024,
  rx: 0.5,
  ry: 0.329
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 14.443,
  cy: 20.881,
  rx: 1.5,
  ry: 2.643
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.124,
  cy: 29.238,
  rx: 3.181,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 32.943,
  cy: 33.238,
  rx: 3,
  ry: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 12.673,
  cy: 14.085,
  rx: 1,
  ry: 1.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M29 36s2 5.927 2 9-2 9-2 9h3s.833-5.986 1-9c.074-1.331 0-4 0-4"
}));

var SvgGiraffe = function SvgGiraffe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGiraffe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Giraffe.2362c1ae.svg";
export { ForwardRef as ReactComponent };